export default __webpack_public_path__ + "static/media/Mobile-05.5879eb07.jpg";